import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WithCsportalAuth from '../../hooks/WithCsportalAuth';
import { getContractTypeVal, getProjectId, getSourceValue, handleRedirection } from '../../lib/common';
import { GetBannerFaqs } from '../../api';
import { handleSetBannerTypeData, handleSetFaqData } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';
import BannerHeader from './Header/BannerHeader';
import BannerFaqs from './BannerFaq/BannerFaqs';
import BannerModal from './BannerModal/BannerModal';
import FaqWrapper from '../common/FaqWrapper';
import { OthersPopup } from '../Popups';
import { DataShimmer, Toast } from '../common';
import { useLocalStorage } from '../../hooks';
import NoDataView from '../../pages/NoDataView';

function BannerHome() {
  const queryParams = new URLSearchParams(window.location.search);
  const jddrrCertificateFlag = queryParams.get('jdrrCertificate');
  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');
  const navigate = useNavigate();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [appState, appDispatch] = useAppState();
  const getBannerType = sessionStorage.getItem('bannerType');
  const [loading, setLoading] = useState(false);
  const [openOthersPopup, setOpenOthersPopup] = useState(!getBannerType);
  const [selectedBannerType, setSelectedBannerType] = useState('');
  const [faqDetails, setFaqDetails] = useState([]);
  const [bannerData, setBannerData] = useState({});
  const [searchQuestion, setSearchQuestion] = useState('');
  const [showBannerModal, setShowBannerModal] = useState(false);
  const [faqResponse, setFaqResponse] = useState(
    appState?.faqData && appState?.faqData.length > 0 ? appState?.faqData : [],
  );
  const [showBannerTypeModal, setShowBannerTypeModal] = useState(false);
  const [hLinkResp, setHLinkResp] = useState('');
  const [activeIndex, setActiveIndex] = useState(-1);
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const projectId = getProjectId();
  const contractVal = getContractTypeVal(projectId);
  const source = getSourceValue();
  const bType = queryParams.get('bType');

  const bannerTypes = [
    {
      title: 'Web Banner',
    },
    {
      title: 'Mobile Banner',
    },
    {
      title: 'JDRR Certificate',
    },
  ];

  if (projectId === 'csportal') {
    bannerTypes.pop();
  }

  const InitializeFaq = (faqParams) => {
    const data = faqParams;
    if (searchQid && searchQid !== '') {
      data?.forEach((ele, i) => {
        if (ele?.id?.toString() === searchQid) {
          data?.splice(i, 1);
          data?.unshift(ele);
        }
      });

      data?.forEach((faq, i) => {
        if (faq?.id?.toString() === searchQid) {
          setActiveIndex(i);
        }
      });
    }
    return data;
  };

  const GetBannerFaqsData = async () => {
    try {
      setLoading(true);
      const paramsData = {
        docId: projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || '',
        parentId: projectId === 'csportal' ? selectedBusiness?.parentid || '' : selectedBusinessGenio?.parentId || '',
        city:
          projectId === 'csportal'
            ? selectedBusiness?.data_city
              ? encodeURIComponent(selectedBusiness?.data_city)
              : ''
            : selectedBusinessGenio?.city
              ? encodeURIComponent(selectedBusinessGenio?.city)
              : '',
      };
      paramsData.key = 'Banner-JDRR';
      paramsData.projectId = projectId;
      const res = await GetBannerFaqs(paramsData);
      if (res?.errorCode === 0) {
        const faqTypeData = res?.result.bannerTypes.filter((eachType) => eachType?.title === getBannerType);
        const activeBannerType = res?.result.bannerTypes.find((eachType) => !eachType.bannerNotSigned);

        let data = [];
        let bannerTypeNotSigned = false;
        if (jddrrCertificateFlag === '1') {
          bannerTypeNotSigned = res?.result?.bannerDataResp?.bannerNotSignedFlag;
          data = (res?.result.bannerTypes && res?.result.bannerTypes?.[2] && res?.result.bannerTypes?.[2]?.faqs) || [];
        } else if (!selectedBannerType && activeBannerType === undefined) {
          const activeType = bType === 'Mobile Banner' ? 'Mobile Banner' : 'Web Banner';
          data = (res?.result.bannerTypes && res?.result.bannerTypes?.[0] && res?.result.bannerTypes?.[0]?.faqs) || [];
          bannerTypeNotSigned = res?.result.bannerTypes && res?.result.bannerTypes?.[0]?.bannerNotSigned;
          sessionStorage.setItem('activeBannerFlag', activeType);
          if (getBannerType) {
            sessionStorage.setItem('bannerType', activeType);
          }
        } else if (!selectedBannerType && activeBannerType) {
          data = (activeBannerType && activeBannerType?.faqs) || [];
          bannerTypeNotSigned = activeBannerType?.bannerNotSigned;
          sessionStorage.setItem('activeBannerFlag', activeBannerType?.title);
          if (getBannerType) {
            sessionStorage.setItem('bannerType', activeBannerType?.title);
          }
        } else {
          data = (faqTypeData && faqTypeData?.[0] && faqTypeData?.[0]?.faqs) || [];
          bannerTypeNotSigned = faqTypeData && faqTypeData?.[0] && faqTypeData?.[0]?.bannerNotSigned;
        }
        let updDataObj = {};
        if (data) {
          const { bannerDataResp } = res?.result || {};
          updDataObj = {
            hLink: bannerDataResp?.hLink || '',
            bannerImg: bannerDataResp?.bannerImg || '',
            status: bannerDataResp?.status || '',
            mobileBannerStatus: bannerDataResp?.mobileBannerStatus || '',
            mobileBannerImg: bannerDataResp?.mobileBannerImg || '',
            bannerNotSigned: bannerTypeNotSigned,
            showWebBannerInProgressImage: bannerDataResp?.showWebBannerInProgressImage,
            webBannerHeaders: bannerDataResp?.webBannerHeaders || {},
            mobileBannerHeaders: bannerDataResp?.mobileBannerHeaders || {},
            mobileBannerRedirectUrl: bannerDataResp?.mobileBannerRedirectUrl || '',
            banner_cta: bannerDataResp?.banner_cta || '',
          };
          setBannerData(updDataObj);
        }

        const result = await InitializeFaq(data);
        setFaqDetails(result);
        setFaqResponse(data);
        handleSetFaqData(appDispatch, {
          faqData: data || [],
        });
        handleSetBannerTypeData(appDispatch, {
          bannerTypeData: { bannerData: updDataObj || {}, faqDetails: result || [] },
        });
      }
      setLoading(false);
    } catch (e) {
      console.log('Err in GetBannerFaqsData', e);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedBannerType || (appState?.bannerTypeData && Object.keys(appState?.bannerTypeData).length === 0)) {
      GetBannerFaqsData();
    } else {
      setBannerData(appState?.bannerTypeData?.bannerData);
      setFaqDetails(appState?.bannerTypeData?.faqDetails);
    }
  }, [selectedBannerType, hLinkResp]);
  const handleClosePopup = (bannerType = '') => {
    setOpenOthersPopup(false);
    setShowBannerTypeModal(false);
    if (!bannerType && !getBannerType) {
      if (projectId === 'csportal') {
        navigate(-1);
      } else {
        navigate(-1);
      }
    }
  };

  const handleSearchFaq = (e) => {
    setSearchQuestion(e.target.value);
    const filteredFaqData =
      faqResponse && faqResponse.filter((each) => each.question.toLowerCase().includes(e.target.value.toLowerCase()));
    setFaqDetails(filteredFaqData);
  };

  document.body.style.overflow = 'unset';
  const hasDocId = projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || '';

  const handleBannerRedirection = () => {
    const redirectionUrl = `https://www.justdial.com/acmp/${getBannerType === 'Web Banner' ? 'WBNR' : 'MBNR'}-${selectedBusiness?.shorturl || ''}?source=${source}&module=cs_csportal&cta_from=&back_url=&support=1&wkwebview=1`;
    handleRedirection(source, redirectionUrl);
  };

  return (
    <>
      {loading || contractVal === null ? (
        <DataShimmer loading={loading} id="ecsfaq" />
      ) : (
        <>
          {getBannerType && (
            <>
              <BannerHeader
                bannerData={bannerData}
                setShowBannerModal={setShowBannerModal}
                setShowBannerTypeModal={setShowBannerTypeModal}
                loading={loading}
                setActiveIndex={setActiveIndex}
                projectId={projectId}
                contractVal={contractVal}
                handleBannerRedirection={handleBannerRedirection}
              />
              {hasDocId && contractVal !== 'free' ? (
                <BannerFaqs
                  faqdetails={faqDetails || []}
                  bannerData={bannerData}
                  setBannerData={setBannerData}
                  loading={loading}
                  searchQuestion={searchQuestion}
                  handleSearchFaq={handleSearchFaq}
                  hLinkResp={hLinkResp}
                  setHLinkResp={setHLinkResp}
                  activeIndex={activeIndex}
                  setActiveIndex={setActiveIndex}
                  projectId={projectId}
                  handleBannerRedirection={handleBannerRedirection}
                />
              ) : (
                <NoDataView pageName={getBannerType || 'Banner'} />
              )}
            </>
          )}
        </>
      )}
      {(openOthersPopup || showBannerTypeModal) && (
        <OthersPopup
          othersData={bannerTypes}
          handleClosePopup={handleClosePopup}
          setSelectedBannerType={setSelectedBannerType}
          id="banner"
        />
      )}

      {showBannerModal && (
        <BannerModal bannerData={bannerData} setShowBannerModal={setShowBannerModal} projectId={projectId} />
      )}
      {appState?.alertSnackbar?.message && <Toast toastMsgObj={appState?.alertSnackbar || {}} />}
    </>
  );
}
export default WithCsportalAuth(FaqWrapper(BannerHome));
